import { FormControl, InputLabel } from "@material-ui/core";
import { FormikProps } from "formik";
import React from "react";
import { PickupItemLocation } from "../../../model/PickupItemLocation";
import ProductList from "../../Common/ProductList/ProductList";
import { PRE_BOOKED_META_KEY, PRE_BOOKED_META_SEPARATOR } from "../models";

interface IProps extends FormikProps<PickupItemLocation> {}

export function PreBookedProductSelect(props: IProps) {
	const { values } = props;
	const key = PRE_BOOKED_META_KEY;
	const metadataItem = values.metadata?.find((x) => x.key === key);

	const selectedIds = metadataItem?.value
		? metadataItem.value.split(PRE_BOOKED_META_SEPARATOR).map((x) => x.trim()).filter(Boolean)
		: [];

	// Flera produkter lagras som "::"-separerat värde under samma metadatanyckel.
	const handleChange = (ids: string[]) => {
		const nextValue = values.metadata ? [...values.metadata] : [];
		const existingIndex = nextValue.findIndex((x) => x.key === key);

		if (ids && ids.length > 0) {
			const value = ids.join(PRE_BOOKED_META_SEPARATOR);
			if (existingIndex >= 0) {
				nextValue[existingIndex] = { key, value };
			} else {
				nextValue.push({ key, value });
			}
		} else if (existingIndex >= 0) {
			nextValue.splice(existingIndex, 1);
		}

		props.setFieldValue("metadata", nextValue);
	};

	return (
		<FormControl fullWidth>
			<InputLabel shrink>Produkter för förbokningar</InputLabel>
			<ProductList
				key={metadataItem?.value ? `${metadataItem.value}-select` : undefined}
				clearable
				multiple
				initialValue={selectedIds}
				showArchived={false}
				onChange={(e) => {
					handleChange(e.selectedIds ?? []);
				}}
				onClear={() => {
					handleChange([]);
				}}
			/>
		</FormControl>
	);
}
